// PLAN2 WP39 — one page.view per client navigation, keyed by the deepest Remix route id (never the URL — it can carry
// ids and codenames). Renders nothing.
import { useEffect } from "react";
import { useLocation, useMatches } from "@remix-run/react";
import { useCsrfToken } from "~/hooks/useActionFetcher";
import { track } from "~/utils/analytics.client";

export function AnalyticsPageViews() {
  const location = useLocation();
  const matches = useMatches();
  const csrf = useCsrfToken();
  const routeId = matches[matches.length - 1]?.id ?? "root";
  useEffect(() => {
    track("page.view", { route: routeId.replace(/[^a-z0-9._:-]/gi, ".").toLowerCase().slice(0, 64) }, csrf);
  }, [location.pathname, routeId, csrf]);
  return null;
}
